const KeyReplyList = () => import('@/views/main/keyReply/list/List.vue')
export default {
  path: '/main/keyReply/list',
  name: 'KeyReplyList',
  component: KeyReplyList,
  children: []
}
